import React from "react";
import { BrowserRouter,Routes,Route } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Register from "../pages/Register";
import { AuthProvider } from "../Hooks/auth/AuthProvider";
import PersistLogin from '../Hooks/Token/PersistLogin'
import ProtectedRoutes from './ProtectedRoutes'
import Dashboard from "../pages/Dashboard";
import CreateWorkspace from "../pages/CreateWorkspace";
import Workspace from "../pages/Workspace";
import CreateProject from "../pages/CreateProject";
import UpdateWorkspace from "../pages/UpdateWorkspace";
import UpdateProject from "../pages/UpdateProject";
import Pricing from "../pages/Pricing"

export default function Routing() {
   return(<>
    <AuthProvider>
    <BrowserRouter>
    <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="login" element={<Login/>}/>
        <Route path="register" element={<Register/>}/>
        <Route path='pricing' element={<Pricing/>} /> 
        <Route element={<PersistLogin/>}>
        <Route element={<ProtectedRoutes/>}>
                <Route path='createProject/:wId' element={<CreateProject />} />
                
                <Route path='workspace/:wId' element={<Workspace />} />
                <Route path='createWorkspace' element={<CreateWorkspace />} />
                <Route path='updateWorkspace/:wId' element={<UpdateWorkspace />} />
                <Route path='updateProject/:cwId/:pId' element={<UpdateProject />} />
                <Route path='dashboard' element={<Dashboard/>} />  
        </Route>
        </Route> 
    </Routes>
    </BrowserRouter>
    </AuthProvider>
    </>
)
}